// Regras puras do rodapé "Sua carteira" da sidebar (mockup "Tela Aeros Dark -
// Atendimentos Nova Entrada"): dois cards fixos com o saldo de SMS e de leads
// e um botão cada para recarregar/comprar. Sem React aqui — só a montagem dos
// descritores que o componente SidebarWallet renderiza.
import { i18n } from "../translate/i18n";

export const formatSaldo = (n) =>
  n === null || n === undefined ? "—" : Number(n || 0).toLocaleString("pt-BR");

// Rotas-alvo dos botões. O card de SMS leva à tela de compra de créditos; o de
// leads à Base de Leads, onde fica o botão "Comprar leads".
export const WALLET_ROUTES = {
  sms: "/creditos-sms",
  leads: "/leads",
};

// Lista dos cards na ordem do mockup. `canSeeSms` reflete a mesma permissão
// que esconde o item "Créditos SMS" do menu (dashboard:view, só admin);
// o card de leads aparece para todos porque a Base de Leads também aparece.
export const walletCards = ({ smsSaldo, leadsSaldo, canSeeSms }) => {
  const cards = [];
  if (canSeeSms) {
    cards.push({
      key: "sms",
      label: i18n.t("mainDrawer.wallet.sms"),
      value: formatSaldo(smsSaldo),
      cta: i18n.t("mainDrawer.wallet.recharge"),
      to: WALLET_ROUTES.sms,
      primary: false,
    });
  }
  cards.push({
    key: "leads",
    label: i18n.t("mainDrawer.wallet.leads"),
    value: formatSaldo(leadsSaldo),
    cta: i18n.t("mainDrawer.wallet.buyMore"),
    to: WALLET_ROUTES.leads,
    primary: true,
  });
  return cards;
};

// Eventos de socket que invalidam um saldo. Os mesmos que as telas de
// Créditos SMS e Base de Leads já escutam — a sidebar fica montada o tempo
// todo, então precisa reagir sozinha.
export const walletSocketEvents = (companyId) => ({
  sms: [`company-${companyId}-sms-recarga`],
  leads: [`company-${companyId}-leads-recarga`, `company-${companyId}-leads`],
});

// Decide se um evento recebido deve recarregar o saldo. Recarga só conta
// quando paga; na busca de leads só o fim (ou falha) muda o saldo.
export const shouldRefreshOnEvent = (eventName, data) => {
  if (eventName.endsWith("-sms-recarga")) return data?.action === "paid";
  if (eventName.endsWith("-leads-recarga")) return data?.action === "paid";
  if (eventName.endsWith("-leads")) return data?.action === "finish" || data?.action === "failed";
  return false;
};
